import { type ReactNode } from 'react';
import styles from './ErrorMessage.module.scss';

interface IErrorMessageProps {
  message: ReactNode;
}

const ErrorMessage = ({ message }: IErrorMessageProps) => (
  <div className={styles.errorMessage}>{message}</div>
);

export default ErrorMessage;
